export async function fetchPaymentEnabled(axios) {
  try {
    const res = await axios.get("/payment_availability");
    return !!res.data.data.enabled;
  } catch (e) {
    return false;
  }
}
